/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES Media List API
 * PR TIMESメディアリスト用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MediaReach,
    MediaReachFromJSON,
    MediaReachFromJSONTyped,
    MediaReachToJSON,
} from './MediaReach';

/**
 * 
 * @export
 * @interface SearchSelectedMediaOutletsRequest
 */
export interface SearchSelectedMediaOutletsRequest {
    /**
     * 選択されているメディアのIDリスト
     * @type {Array<number>}
     * @memberof SearchSelectedMediaOutletsRequest
     */
    selectedMediaOutletIds: Array<number>;
    /**
     * 検索キーワードのリスト
     * @type {Array<string>}
     * @memberof SearchSelectedMediaOutletsRequest
     */
    searchKeywords: Array<string>;
    /**
     * メディア種別のIDリスト
     * @type {Array<number>}
     * @memberof SearchSelectedMediaOutletsRequest
     */
    mediaTypeIds: Array<number>;
    /**
     * 
     * @type {Array<MediaReach>}
     * @memberof SearchSelectedMediaOutletsRequest
     */
    reaches: Array<MediaReach>;
}

export function SearchSelectedMediaOutletsRequestFromJSON(json: any): SearchSelectedMediaOutletsRequest {
    return SearchSelectedMediaOutletsRequestFromJSONTyped(json, false);
}

export function SearchSelectedMediaOutletsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchSelectedMediaOutletsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'selectedMediaOutletIds': json['selected_media_outlet_ids'],
        'searchKeywords': json['search_keywords'],
        'mediaTypeIds': json['media_type_ids'],
        'reaches': ((json['reaches'] as Array<any>).map(MediaReachFromJSON)),
    };
}

export function SearchSelectedMediaOutletsRequestToJSON(value?: SearchSelectedMediaOutletsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'selected_media_outlet_ids': value.selectedMediaOutletIds,
        'search_keywords': value.searchKeywords,
        'media_type_ids': value.mediaTypeIds,
        'reaches': ((value.reaches as Array<any>).map(MediaReachToJSON)),
    };
}

